import request from "@/http/request"
import {
  getExamLoginAbnormal,
  getExamLoginAbnormalInfo,
} from '@/http/api'

export const getExamLoginAbnormalFn = (data) => {
    return request({
        url: getExamLoginAbnormal,
        data
    })
}
export const getExamLoginAbnormalInfoFn = (data) => {
  return request({
      url: getExamLoginAbnormalInfo,
      data
  })
}